/* eslint-disable max-len */
import React from 'react';

const NewInfoIcon: React.FC = () => {
	return (
		<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
			<circle cx="8" cy="8" r="7" fill="#B6B7CC"/>
			<path d="M7.8846 3.42773C7.32117 3.42773 6.85718 3.9083 6.85718 4.45515C6.85718 5.01858 7.32117 5.48257 7.8846 5.48257C8.43145 5.48257 8.91201 5.01858 8.91201 4.45515C8.91201 3.9083 8.43145 3.42773 7.8846 3.42773ZM7.10575 7.05684V12.8579H8.64687V7.05684H7.10575Z" fill="white"/>
		</svg>
	);
}

export default NewInfoIcon;